export default __webpack_public_path__ + "static/media/Step3.53283a3d.png";